module.exports = __webpack_public_path__ + "img/evaluate_gray_5.fa5bc254.png";